import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=46471038&scoped=true&"
import script from "./pc-sheet.ts?vue&type=script&lang=ts&"
export * from "./pc-sheet.ts?vue&type=script&lang=ts&"
import style0 from "./sheet.vue?vue&type=style&index=0&id=46471038&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46471038",
  null
  
)

export default component.exports